<template>
    <div class="card">
        <div class="card-body p-0">
            <ul class="list-group list-group-flush px-1 py-1"> 
                <li v-if="loading" class="list-group-item text-secondary text-center">
                    <h5><i class="fa fa-spinner fa-pulse fa-fw"></i></h5>
                </li>
                <template v-else>
                    <template v-if="bulletins.length">
                        <li v-for="bulletin in bulletins" v-bind:key="bulletin.id" class="list-group-item">
                            <bulletin
                                :id = bulletin.id
                                :sender = bulletin.sender
                                :expiry_time = bulletin.expiry_time
                                :dismissable = !!bulletin.dismissable 
                                :text = bulletin.text
                                @bulletin-dismissed="removeBulletin"
                            ></bulletin>
                        </li>
                    </template>
                    <li v-else class="list-group-item text-secondary text-center">
                        <h5>No Bulletins Active</h5>
                    </li>
                    <a v-if="canCreate" href="#"
                    class="list-group-item list-group-item-action text-center text-secondary py-3"
                    data-toggle="modal" data-target="#newBulletin"><i
                    class="fas fa-2x fa-plus-circle"></i></a>
                </template>
            </ul>
        </div>
    </div>
</template>

<script>
import Bulletin from './Bulletin'

export default {
    components: {
        Bulletin
    },

    props: {
        canCreate: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            bulletins: [],
            bulletin_id: '',
            edit: false,
            loading: false,
        }
    },

    created() {
        this.fetchBulletins();
    },

    mounted() {
        var self = this;
        BulletinEventBus.$on('reload', function() {
            self.fetchBulletins();
        });
    },

    methods: {
        fetchBulletins() {
            this.loading = true;
            var self = this;
            axios.get('api/bulletins/highlights')
            .then(function (response) {
                self.loading = false;
                // convert to an array (so we can easily get the length)
                self.bulletins = Object.values(response.data); 
            })
            .catch(function (error) {
                console.log(error);
            });
        },

        removeBulletin(bulletin) {
            let i = this.bulletins.map(item => item.id).indexOf(bulletin.id) // find index of your object
            this.bulletins.splice(i, 1) // remove it from array
        }

        
    }
}
</script>